<!-- 资源管理-电子书管理-电子书列表-详情/审核-内容-吴影茹 -->
<template>
  <div>
    <!-- 基础信息 -->
    <a-descriptions bordered :column="24" :labelStyle="{ width: '180px' }" :contentStyle="{ width: '300px' }">
      <a-descriptions-item label="电子书封面" :span="24">
        <a-image :src="info.cover" style="width: 130px; aspect-ratio: 3.6/5" />
      </a-descriptions-item>
      <a-descriptions-item label="电子书标题" :span="24">{{ info.title }}</a-descriptions-item>
      <a-descriptions-item label="书籍类型" :span="24">{{ info.ebookTypeLabel }}</a-descriptions-item>
      <a-descriptions-item label="作者" :span="12">{{ info.author }}</a-descriptions-item>
      <a-descriptions-item label="出版时间" :span="12">{{ info.publishingDate }}</a-descriptions-item>
      <a-descriptions-item label="出版社" :span="24">{{ info.publishingHouse }}</a-descriptions-item>
      <a-descriptions-item label="简介" :span="24">{{ info.intro || '-' }}</a-descriptions-item>
      <a-descriptions-item label="状态" :span="12" v-if="type == 'detail'">
        <a-tag :color="info.status == 1 ? 'success' : 'default'">{{
          statusList.find((item) => {
            return item.value == info.status
          })?.label || '-'
        }}</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="附件" :span="type == 'detail' ? 12 : 24">
        <div class="link_text" @click="previewUrl">点击预览电子书</div>
      </a-descriptions-item>
      <a-descriptions-item label="创建人" :span="12">{{ info.createBy }}</a-descriptions-item>
      <a-descriptions-item label="创建时间" :span="12">{{ info.createTime }}</a-descriptions-item>
      <a-descriptions-item label="审核人员" :span="12" v-if="info.reviewer && type != 'check' && type != 'previewDetail'">{{
        info.reviewer
      }}</a-descriptions-item>
      <a-descriptions-item label="审核时间" :span="12" v-if="info.reviewTime && type != 'check' && type != 'previewDetail'">{{
        info.reviewTime
      }}</a-descriptions-item>
      <a-descriptions-item label="审核备注" :span="24" v-if="info.reviewer && type != 'check' && type != 'previewDetail'">{{
        info.remark || '-'
      }}</a-descriptions-item>
      <a-descriptions-item label="浏览量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.viewCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="收藏量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.collectCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="分享量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.shareCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="点赞量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.likeCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="下载量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.downloadCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="评分" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.overallRating || 0
      }}</a-descriptions-item>
    </a-descriptions>
    <!-- 审核 -->
    <div v-if="type == 'check'">
      <OyForm
        ref="checkFormRef"
        :schema="formSchema"
        v-model="form"
        layout="horizontal"
        labelAlign="right"
        :labelCol="{ style: { width: '70px' } }"
        style="margin-top: 20px"
      >
      </OyForm>
      <div class="row_center_center">
        <a-button type="primary" style="width: 200px" @click="submitHandler" :loading="checkLoading">提交</a-button>
      </div>
    </div>
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import { EbookDetailInfo } from './types'
import { useRouter } from 'vue-router'
import { useDict } from '@/composable/useDict'
const { getDictData } = useDict()
const router = useRouter()
import * as api from './service'
import { message } from 'ant-design-vue'
import { filePreview } from '@admin-base/core'

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  //   detail普通详情  check审核   rejectDetail拒绝详情   previewDetail预览详情
  type: {
    type: String,
    default: 'detail'
  }
})

onMounted(async () => {
  await getStatusList()
  await getTypeList()
  getDetail()
})
const emit = defineEmits(['submit'])

const info = ref<EbookDetailInfo>({
  ebookId: '',
  cover: '',
  title: '',
  attachUrl: ''
})

const getDetail = () => {
  api.ebookDetail(props.id).then((res) => {
    info.value = { ...res.data }
    info.value.ebookTypeLabel =
      typeList.value.find((item) => {
        return item.value == info.value.ebookType
      })?.label || '-'
  })
}

// 状态列表
const statusList = ref<any>([])
// 获取状态列表
const getStatusList = async () => {
  statusList.value = await getDictData('resource_status_manage')
}

// 类型列表
const typeList = ref<any>([])
// 获取类型列表
const getTypeList = async () => {
  typeList.value = await getDictData('ebook_type')
}

// 预览电子书
const previewUrl = () => {
  filePreview(info.value.attachUrl)
}

// 审核
const form = ref<any>({
  reviewStatus: 1,
  remark: ''
})
const formSchema = ref<any>([
  {
    type: 'radio',
    colSpan: 24,
    label: '结果',
    field: 'reviewStatus',
    required: true,
    ruleText: '请选择结果',
    props: {
      options: [
        { value: 1, label: '通过' },
        { value: 2, label: '不通过' }
      ]
    }
  },
  {
    type: 'textarea',
    colSpan: 24,
    label: '备注',
    field: 'remark',
    required: true,
    props: {
      rows: 4
    },
    showWhen: (model) => form.value.reviewStatus == 2
  },
  {
    type: 'textarea',
    colSpan: 24,
    label: '备注',
    field: 'remark',
    props: {
      rows: 4
    },
    showWhen: (model) => form.value.reviewStatus == 1
  }
])

const checkFormRef = ref<any>(null)
const checkLoading = ref(false)

// 提交审核
const submitHandler = () => {
  checkFormRef.value.validate().then((valid) => {
    checkLoading.value = true

    api
      .ebookReview({
        ebookId: props.id,
        reviewStatus: form.value.reviewStatus,
        remark: form.value.remark
      })
      .then((res) => {
        message.success('操作成功')
        checkLoading.value = false
        resetHandler()
        emit('submit')
      })
      .catch(() => {
        checkLoading.value = false
      })
  })
}

// 重置
const resetHandler = () => {
  form.value = {
    reviewStatus: 1,
    remark: ''
  }
  checkFormRef.value.reset()
}
</script>
            
<style lang="scss" scoped>
</style>